import { useTranslation } from "react-i18next";
import useAuth from "src/hooks/selectors/useAuth";
import TabNav from "src/components/layout/TabNav";

const ProfileTabs = () => {
	const { t } = useTranslation("profile-view", {
		keyPrefix: "profile-tabs",
	});
	const auth = useAuth();
	let tabs = [
		{
			to: "/profile/show",
			label: t("my-profile"),
		},
	];

	if (auth.type === "company") {
		tabs = [
			...tabs,
			{
				to: "/profile/billing",
				label: t("my-subscription"),
			},
			{
				to: "/profile/company",
				label: t("company-profile"),
			},
			{
				to: "/profile/companies",
				label: t("companies"),
			},
			{
				to: "/profile/teams",
				label: t("teams"),
			},
			{
				to: "/profile/users",
				label: t("users"),
			},
		];
	}

	return (
		<div className="flex flex-col mb-4">
			<TabNav {...{ tabs }} />
		</div>
	);
};

export default ProfileTabs;
